import { render, staticRenderFns } from "./SchemaManager.vue?vue&type=template&id=2986589a&scoped=true"
import script from "./SchemaManager.vue?vue&type=script&lang=ts"
export * from "./SchemaManager.vue?vue&type=script&lang=ts"
import style0 from "./SchemaManager.vue?vue&type=style&index=0&id=2986589a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986589a",
  null
  
)

export default component.exports